// @flow
import BoxTalking from "./BoxTalking";

export default BoxTalking;
